import hoodie from '../../images/PortfolioImg/Apparel Items/Hoodies/h1.jpeg'
import sweet from '../../images/PortfolioImg/Apparel Items/Sweatshirts/s1.jpeg'
import tshirt from '../../images/PortfolioImg/Apparel Items/T-Shirts/ts4.jpeg'
import jersey from '../../images/PortfolioImg/Apparel Items/Jerseys/j3.jpeg'



const ApparelItemsData = [
    {
      "id": 1,
      "name": "Hoodies",
      "description": "Custom hoodies, perfect for casual wear and keeping your brand cozy and stylish.",
      "apperal":"apperal1",
      "image" : hoodie
    },
    {
      "id": 2,
      "name": "Sweatshirts",
      "description": "Personalized sweatshirts that combine comfort and style, ideal for everyday wear.",
      "apperal":"apperal3",
      "image" : sweet
    },
    {
      "id": 3,
      "name": "T-shirts",
      "description": "Custom T-shirts with your logo or design, great for casual promotions and giveaways.",
      "apperal":"apperal5",
      "image" : tshirt
    },
    {
      "id": 4,
      "name": "Jerseys",
      "description": "Sports jerseys with custom designs, perfect for teams, events, and athletic promotions.",
      "apperal":"apperal2",
      "image" : jersey
    }
  ];
  
  export default ApparelItemsData;
  